import styled from 'styled-components';

import { device } from '@/styles/helpers';

interface ScScreenModalProps {
  blockImage: string;
  blockImageMobile?: string;
}

export const ScScreenModal = styled.div<ScScreenModalProps>`
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(20px);
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  & .modal__wrapper {
    background: url(${({ blockImage }) => blockImage}) no-repeat;
    background-size: 100% 100%;
    max-width: 600px;
    width: 100%;
    max-height: 354px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    font-weight: 700;
    padding: 2rem;
    margin: 0 1rem;
    @media (${device.mobile}) {
      background-image: url(${({ blockImageMobile }) => blockImageMobile});
      max-height: 480px;
    }

    & .wrapper {
      overflow: auto;
    }

    & h1 {
      color: ${({ theme }) => theme.yellowColor};
      letter-spacing: 0.44px;
      font-size: 22px;
      line-height: 28px;
      margin-bottom: 12px;
      @media (${device.mobile}) {
        font-size: 20px;
        line-height: 26px;
      }

      &.yourPrize-2 {
        color: ${({ theme }) => theme.greenLightColor};
      }
    }
    & .text-wrapper,
    & .text-container,
    & .inner {
      display: flex;
      flex-direction: column;
    }

    & .text-wrapper {
      gap: 4px;
      margin-bottom: 32px;
    }

    & .firstPrize {
      font-size: 40px;
      line-height: 48px;
      letter-spacing: 1.2px;
      @media (${device.mobile}) {
        font-size: 32px;
        line-height: 40px;
        letter-spacing: 0.96px;
      }
    }

    & .secondPrize {
      font-size: 32px;
      line-height: 40px;
      @media (${device.mobile}) {
        font-size: 28px;
        line-height: 36px;
      }
    }

    & .text-container,
    & .code-container {
      margin-bottom: 24px;
    }

    & .code-container div {
      margin-bottom: 0;
    }

    & a,
    & button {
      max-width: 280px;
      width: 100%;
      font-size: 1rem;
    }

    & .inner {
      align-items: center;
      gap: 16px;
      width: 100%;
    }
  }
`;
